import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/auth/api";
import Loader from "@/components/Loader";

function PanelUserDetail() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [activeTab, setActiveTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isAnimating, setIsAnimating] = useState(false); // For tab animation

  useEffect(() => {
    const getPanelUserData = async () => {
      try {
        setLoading(true);
        const resp = await api.get(`/PanelHome/panel/panelUserDetail?Id=${id}`);
        const result = resp.data.result || {};

        if (Object.keys(result).length > 0) {
          setData(result);
          setActiveTab(Object.keys(result)[0]); // Set first tab key as default
        } else {
          setData({});
          setActiveTab("");
        }
      } catch (err) {
        setError("Failed to load data. Please try again.");
        console.error("Error fetching user data:", err);
      } finally {
        setLoading(false);
      }
    };

    getPanelUserData();
  }, [id]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <p className="text-red-600">{error}</p>
      ) : (
        <div className="p-4 pt-16">
          <div className="mb-4">
            <div className="flex gap-2 mt-2">
              {Object.keys(data).map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    if (tab === activeTab) return;
                    setIsAnimating(true);
                    setTimeout(() => {
                      setActiveTab(tab);
                      setIsAnimating(false);
                    }, 150); // Match duration of transition
                  }}
                  className={`px-4 py-2 ${
                    activeTab === tab
                      ? "border-b-4 border-b-[var(--mainCol)]"
                      : ""
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          {activeTab && (
            <div
              className={`transition-opacity duration-300 ${
                isAnimating ? "opacity-0" : "opacity-100"
              }`}
            >
              {Object.entries(data[activeTab]).map(
                ([sectionTitle, sectionData]) => (
                  <div key={sectionTitle} className="mb-8">
                    <h3 className="text-lg font-semibold mb-2">
                      {sectionTitle}
                    </h3>
                    {Array.isArray(sectionData) && sectionData.length > 0 ? (
                      <div className="overflow-auto">
                        <table className="min-w-full border border-gray-300 text-xs">
                          <thead className="bg-gray-100">
                            <tr>
                              {Object.keys(sectionData[0]).map((key) => (
                                <th
                                  key={key}
                                  className="border px-2 py-1 text-left"
                                >
                                  {key}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {sectionData.map((item, index) => (
                              <tr
                                key={index}
                                className="odd:bg-white even:bg-gray-50"
                              >
                                {Object.entries(item).map(
                                  ([key, value], idx) => (
                                    <td key={idx} className="border px-2 py-1 text-center">
                                      {key === "profileImage" &&
                                      typeof value === "string" ? (
                                        <img
                                          src={value}
                                          alt="Profile"
                                          className="w-10 h-10 rounded-full object-cover"
                                        />
                                      ) : typeof value === "boolean" ? (
                                        value ? "✔️" : "❌"
                                      ) : value === null ? (
                                        "—"
                                      ) : (
                                        value
                                      )}
                                    </td>
                                  )
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p className="text-gray-500">No data available</p>
                    )}
                  </div>
                )
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default PanelUserDetail;
